// Store is where all data required by our App will live.
// Also, any data that is required by the App during its execution, is received from the Store.
//import devTools from "remote-redux-devtools";
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
//import { persistStore, persistCombineReducers } from "redux-persist";
//import storage from 'redux-persist/lib/storage';
//import { persistReducer } from 'redux-persist';
import { AsyncStorage, Platform } from 'react-native';
import WebAsyncStorage from '@react-native-async-storage/async-storage';
import reducers from '../reducers';

//import { createReactNavigationReduxMiddleware } from 'react-navigation-redux-helpers';
//import { createNetworkMiddleware } from 'react-native-offline';

/*
const config = {
  key: 'root',
  storage: AsyncStorage,
  blacklist: ['loginReducer'],
}*/
const rootPersistConfig = {
	key: 'root',
	storage: Platform.OS == 'web' ? WebAsyncStorage : AsyncStorage
};

//const reducer = persistCombineReducers(config, reducers)
//const navMiddleware = createReactNavigationReduxMiddleware('root', state => state.nav);
//const networkMiddleware = createNetworkMiddleware();

export default function configureStore(onCompletion: () => void): any {
	const composeEnhancers =
		typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
			? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
					// Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
			  })
			: compose;

	//so this is like compose()
	const enhancer = composeEnhancers(
		applyMiddleware(thunk)
		//applyMiddleware(navMiddleware)
		//applyMiddleware(networkMiddleware)
		/*devTools({
      name: "nativestarterkit",
      realtime: true
    })*/
	);
	//persistReducer(rootPersistConfig, )
	const store = createStore(reducers, enhancer);
	//let persistor = persistStore(store, onCompletion);

	return store;
}
